import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileMenuSearch from "./sub-components/MobileSearch";
import MobileNavMenu from "./sub-components/MobileNavMenu";
import MobileLangCurChange from "./sub-components/MobileLangCurrChange";
import MobileWidgets from "./sub-components/MobileWidgets";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";
import { getUserFromToken } from "../../services/User";
import "../../assets/css/MobileMenu.css"; // Import file css mình sẽ viết ở dưới
import { getToken, removeToken } from "../../services/AuthStorage";
import { clearVoucherFromLocal } from "../../services/Voucher";
const MobileMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");

  useEffect(() => {
    const offCanvasNav = document.querySelector("#offcanvas-navigation");
    const offCanvasNavSubMenu = offCanvasNav?.querySelectorAll(".sub-menu") || [];
    const anchorLinks = offCanvasNav?.querySelectorAll("a") || [];

    for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
      offCanvasNavSubMenu[i].insertAdjacentHTML(
        "beforebegin",
        "<span class='menu-expand'><i></i></span>"
      );
    }

    const menuExpand = offCanvasNav?.querySelectorAll(".menu-expand") || [];
    for (let i = 0; i < menuExpand.length; i++) {
      menuExpand[i].addEventListener("click", e => {
        sideMenuExpand(e);
      });
    }

    for (let i = 0; i < anchorLinks.length; i++) {
      anchorLinks[i].addEventListener("click", () => {
        closeMobileMenu();
      });
    }

    checkAuth();
    window.addEventListener("storage", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  const sideMenuExpand = e => {
    e.currentTarget.parentElement.classList.toggle("active");
  };

  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector("#offcanvas-mobile-menu");
    offcanvasMobileMenu.classList.remove("active");
  };

  const isAuthenticated = () => {
    const token = getToken();
    if (!token) return false;
  
    try {
      const { exp } = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
  
      if (!exp || exp < now) {
        removeToken(); // ✅ Xoá token nếu hết hạn
        clearVoucherFromLocal();
        localStorage.removeItem("checkoutForm");
        return false;
      }
  
      return true;
    } catch (error) {
      console.error("Invalid token:", error);
      removeToken(); // ✅ Token lỗi cũng xoá luôn
      localStorage.removeItem("checkoutForm");
      clearVoucherFromLocal();
      return false;
    }
  };

  const checkAuth = () => {
    const auth = isAuthenticated();
    setIsLoggedIn(auth);

    if (auth) {
      const user = getUserFromToken();
      if (user) {
        setUsername(user.unique_name);
      }
    } else {
      setUsername("");
    }
  };

  const handleLogout = () => {
    removeToken(); //  Thay vì localStorage.removeItem("token")
    clearVoucherFromLocal();
    localStorage.removeItem("checkoutForm");
    setIsLoggedIn(false);
    setUsername("");
    closeMobileMenu();
    navigate("/");
  };

  return (
    <div className="offcanvas-mobile-menu" id="offcanvas-mobile-menu">
      <button
        className="offcanvas-menu-close"
        id="mobile-menu-close-trigger"
        onClick={() => closeMobileMenu()}
      >
        <i className="pe-7s-close"></i>
      </button>
      <div className="offcanvas-wrapper">
        <div className="offcanvas-inner-content">

          {/* mobile search */}
          <MobileMenuSearch />

          {/* mobile nav menu */}
          <MobileNavMenu />

          {/* mobile language and currency */}
          <MobileLangCurChange />

          {/* mobile account login/logout */}
          <div className="mobile-account-menu">
            {isLoggedIn ? (
              <div className="logged-in-block">
                <span className="user-greeting">{t("hello")}, {username}</span>
                <ul className="account-links">
                  <li>
                    <Link to="/my-account" onClick={closeMobileMenu}>{t("myAccount")}</Link>
                  </li>
                  <li>
                    <Link to="/my-orders" onClick={closeMobileMenu}>{t("myOrders")}</Link>
                  </li>
                  <li>
                    <button className="logout-btn" onClick={handleLogout}>
                      {t("logout")}
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <div className="guest-block">
                <ul className="account-links">
                  <li>
                    <Link to="/login-register" onClick={closeMobileMenu}>{t("login")}</Link>
                  </li>
                  <li>
                    <Link to="/login-register" onClick={closeMobileMenu}>{t("register")}</Link>
                  </li>
                </ul>
              </div>
            )}
          </div>

          {/* mobile widgets */}
          <MobileWidgets />

        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
